import { API } from "@swivl-mono/api-helper";
import { SwivlChat } from "@swivl-mono/chat";
import { Channel, DefaultEmbedConfig, ServerEnvironment, TranscriptStatus, UserInterface, VarKey } from "@swivl-mono/types";
import { Spinner } from "@swivl-mono/ui";
import { useEffect, useState } from "react";
import { useMatch, useParams, useSearchParams } from "react-router-dom";

import { Member } from "../../../../Models/Member/Member.Current";
import { NavBar } from "../../../../Models/NavBar/NavBar.Model";
import BotUserTranscriptDetails from "./BotUserDetails/BotUserTranscriptDetails";
import RenewButton from "./RenewButton/RenewButton";
import "./TranscriptView.scss";

// import RenewButton from "./RenewButton/RenewButton";

export default function TranscriptView() {
  const match = useMatch("/transcript/:userId");
  const userId = match?.params.userId ? parseInt(match.params.userId) : undefined;

  const [user, setUser] = useState<UserInterface | undefined>(undefined);
  const [messages, setMessages] = useState<any[]>([]);
  const [expiresAt, setExpiresAt] = useState<Date | undefined>(undefined);
  const [transcriptStatus, setTranscriptStatus] = useState<TranscriptStatus>(TranscriptStatus.Loading);
  console.log("transcriptStatus :", transcriptStatus);

  const [params] = useSearchParams();

  useEffect(() => {
    // if (bot.hasEscalations)
    NavBar.set(
      <>
        <NavBar.Component.Title title={"Conversation Transcript"} />
        {Member.member && user ? <RenewButton user={user} expiresAt={expiresAt} /> : null}
      </>,
      null,
      null,
      "Conversations"
    );
  }, [user, expiresAt]);

  //   useEffect(() => {
  //     if (!user) {
  //         return;
  //     }
  //     if (transcriptStatus === TranscriptStatus.Valid) {
  //         API.Messages.getAllMessages(uuser., userId).then((messages) => {

  //         setMessages(messages);

  //     }).catch((e) => {

  //     })
  //     }
  //     }, [user, transcriptStatus])
  const channel = params.get("channel") as Channel | undefined;

  useEffect(() => {
    if (!userId) {
      return;
    }

    API.Messages.getMessagesForTranscript(userId, channel)
      .then((transcript) => {
        if (transcript.status === TranscriptStatus.Valid && transcript.user && transcript.messages) {
          setUser(transcript.user);
          setMessages(transcript.messages);
          if (transcript.expiresAt) {
            setExpiresAt(new Date(transcript.expiresAt));
          }
        }
        setTranscriptStatus(transcript.status);
      })
      .catch((e) => {});
    // API.Users.getUserById(userId).then((user) => {
    //     setUser(user);

    // return API.Vars.getVar(user, VarKey.UserTranscriptAccessExpiresAt)
    // }).then((expiresAtString) => {
    //     if (expiresAtString) {
    //         const  expiresAt = new Date(expiresAtString);
    //         if (!expiresAt) {
    //             setTranscriptStatus(TranscriptStatus.InvalidUserId);
    //             return;
    //         }
    //         if (expiresAt < new Date()) {
    //             setTranscriptStatus(TranscriptStatus.Expired);
    //             return;
    //         }

    //         setTranscriptStatus(TranscriptStatus.Valid);
    //     } else {
    //                         setTranscriptStatus(TranscriptStatus.InvalidUserPermissions);

    //     }
    // }).catch((e) => {
    //
    // } )
  }, [userId, channel]);

  // useEffect(() => {

  //     if (!userId) {
  //         setTranscriptStatus(TranscriptStatus.InvalidBotUserId);
  //         return;
  //     }

  //     const fetchData = async () => {
  //         if (isLoadingUser) {
  //             return;
  //         }
  //         let _botUser: BotUser = await BotUser.getById(botUserId);
  //         if (!_botUser) {
  //             setTranscriptStatus(TranscriptStatus.InvalidBotUserId);
  //             return;
  //         }
  //         if (_botUser.get("transcriptAccessExpires")  && _botUser.get("transcriptAccessExpires") > new Date()) {

  //         setTranscriptStatus(TranscriptStatus.Valid);
  //         setBotUser(_botUser);
  //         return;
  //         }

  //         if (user) {
  //             if (!UserModel.hasPermissionsForBot(_botUser.get("bot").id)) {
  //                 setTranscriptStatus(TranscriptStatus.InvalidUserPermissions);
  //                 return;
  //             }
  //             setTranscriptStatus(TranscriptStatus.Valid);
  //             setBotUser(_botUser);
  //             return;
  //         } else {
  //             if (_botUser.get("transcriptAccessExpires") < new Date()) {
  //                 setTranscriptStatus(TranscriptStatus.Expired);
  //                 return;
  //             }
  //             setTranscriptStatus(TranscriptStatus.Valid);
  //             setBotUser(_botUser);
  //             return;
  //         }

  //     }
  //     fetchData().catch((e) => {

  //         setTranscriptStatus(TranscriptStatus.Error);
  //     })
  // }, [botUserId, user, isLoadingUser])

  if (user && transcriptStatus === TranscriptStatus.Valid) {
    const config = { ...DefaultEmbedConfig, orgId: user?.orgId, server: import.meta.env.VITE_SERVER_URL }; //,"startOnQuest":null,"position":"bottom-right","startConversationClosed":false,"startOpen":true,"loadPastMessages":false,"avatarURL":"https://swivl-uploads-production.s3.amazonaws.com/6c08334665295793d46533dd870a8bb5_avatar.png","showAvatarInHeader":false,"showAvatarWithTimestamp":true,"headerText":"Chat with <b>Storage R Us</b>","primaryFont":"'Poppins', sans-serif;","secondaryFont":"'Poppins', sans-serif;","loadPastMessagesColor":"#DAD3D0","loadPastMessagesHoverColor":"#C3BCB9","loadPastMessagesActiveColor":"#A8A4A2","loadPastMessagesSpinnerFill":"#00CABE","headerBackground":"#ffffff","headerColor":"#000000","bodyBackground":"#ffffff","userBubbleBackground":"#ECECEC","userBubbleColor":"#000000","botBubbleBackground":"#ECECEC","botBubbleColor":"#000000","timestampColor":"#949494","formBackground":"#FFFFFF","formColor":"#000000","sendButtonBackground":"#0c1689","sendButtonColor":"#FFFFFF","sendButtonHoverBackground":"#2633ba","sendButtonHoverColor":"#FFFFFF","sendButtonActiveBackground":"#0c1689","sendButtonActiveColor":"#FFFFFF","primaryButtonBackground":"#d0021b","primaryButtonColor":"#FFFFFF","primaryButtonHoverBackground":"#0c1689","primaryButtonHoverColor":"#FFFFFF","primaryButtonActiveBackground":"#0c1689","primaryButtonActiveColor":"#FFFFFF","secondaryButtonBackground":"#0c1689","secondaryButtonColor":"#FFFFFF","secondaryButtonHoverBackground":"#fd8102","secondaryButtonHoverColor":"#FFFFFF","secondaryButtonActiveBackground":"#0c1689","secondaryButtonActiveColor":"#FFFFFF","tertiaryButtonBackground":"#24488d","tertiaryButtonColor":"#FFFFFF","tertiaryButtonHoverBackground":"#ff3366","tertiaryButtonHoverColor":"#FFFFFF","tertiaryButtonActiveBackground":"#24488d","tertiaryButtonActiveColor":"#FFFFFF","ctaStartOnQuest":"9LC7DdWwoE","showCTA":false,"ctaTitle":"Chucks Cool CTA","ctaImageURL":"https://swivl-cdn.s3-us-west-1.amazonaws.com/test%402x.png","ctaBody":"This was made in the embed builder.","ctaDelay":"5","ctaAnalytics":null,"collapsedStyle":"dot","dotText":"How can I help?","showCloseButton":true,"showAvatar":true,"questSlug":"","linkColor":"#fd8102","linkHoverColor":"#0c1689","dotDesktopLeftOffset":155,"bodyDesktopLeftOffset":155,"preloadVariables":{"StoreBrandId":"Chuck1"}}
    const selectedChannelClass = "text-lg font-medium text-grey-900 underline underline-offset-4";
    const deselectedChannelClass = "text-lg font-medium text-grey-600 hover:text-grey-900";
    return (
      <div className="TranscriptView PageThreeColumn">
        <div className="column usersColoumn">
          <div className="botUser">{user?.name}</div>
        </div>
        <div className="column">
          <div className="relative flex h-12 items-center border-b border-grey-100 bg-white pr-4 pl-8">
            {/* channel select tabs */}
            <div className="flex h-full grow items-center gap-8">
              <p>Channel:</p>
              <a href={`/transcript/${userId}`} className={!channel ? selectedChannelClass : deselectedChannelClass}>
                All
              </a>
              <a
                href={`/transcript/${userId}?channel=${Channel.WEB}`}
                className={channel === Channel.WEB ? selectedChannelClass : deselectedChannelClass}
              >
                Web
              </a>
              <a
                href={`/transcript/${userId}?channel=${Channel.SMS}`}
                className={channel === Channel.SMS ? selectedChannelClass : deselectedChannelClass}
              >
                SMS
              </a>
              <a
                href={`/transcript/${userId}?channel=${Channel.VOICE}`}
                className={channel === Channel.VOICE ? selectedChannelClass : deselectedChannelClass}
              >
                Voice
              </a>
            </div>
          </div>
          <div className="chatRow botUserConversation">
            {messages && messages.length > 0 && (
              <SwivlChat
                key={"id" + userId}
                hideForm={true}
                isReadOnly={true}
                canTakeOver={false}
                parentControlsStart={false}
                isConversationTakenOver={false}
                config={config as unknown as any}
                auth={undefined}
                thirdPartyId={undefined}
                generateCSS={true}
                isOpen={true}
                preloadedMessages={messages}
                showSystemEvents={true}
                server={import.meta.env.VITE_SERVER_URL}
                webSocketServer={import.meta.env.VITE_CHANNELS_WEBSOCKET_URL}
                isMobile={false}
                commandCallback={(command) => {}}
                channel={Channel.WEB}

                // notificationsServer={"swivl-notifications.ngrok.io"}
                //   environment={ServerEnvironment.PRODUCTION}
              />
            )}
            {!messages || (messages.length === 0 && <div className="noMessages p-10 text-center">No messages found for this conversation.</div>)}
          </div>
          <div className="chatForm">
            This is the transcript for a single conversation.
            <br />
            To interact with this customer, navigate to the Conversations section.
          </div>
        </div>
        <div className="column">{/* <BotUserTranscriptDetails item={botUser} bot={botUser.get("bot")} /> */}</div>
      </div>
    );
  }

  return (
    <div className="TranscriptView PageThreeColumn">
      <div className="column usersColoumn"></div>
      <div className="column">
        <div className="chatRow botUserConversation">
          {(transcriptStatus === TranscriptStatus.InvalidUserPermissions || transcriptStatus === TranscriptStatus.Expired) && (
            <div className="transcriptError">
              <div className="icon">⌛️</div>
              <div className="title">This link has expired</div>
              <div className="message">Contact your manager for a new link</div>
            </div>
          )}

          {transcriptStatus === TranscriptStatus.Error && (
            <div className="transcriptError">
              <div className="icon">😞</div>
              <div className="message">There was an error loading this conversation</div>
            </div>
          )}
        </div>
        <div className="chatForm">{transcriptStatus === TranscriptStatus.Loading && <Spinner />}</div>
      </div>
      <div className="column">
        {/*
        {transcriptStatus === TranscriptStatus.Loading && (<div>Loading</div>)}
        {transcriptStatus === TranscriptStatus.Error && (<div>Error</div>)}
        {transcriptStatus === TranscriptStatus.InvalidUserId && (<div>InvalidUserId</div>)}
        {transcriptStatus === TranscriptStatus.InvalidUserPermissions && (<div>InvalidUserPermissions</div>)}

        {transcriptStatus === TranscriptStatus.Expired && (<div>Expired</div>)}
        {(transcriptStatus === TranscriptStatus.Valid && (<div>Valid</div>))} */}
      </div>
    </div>
  );

  return <div className="TranscriptView"></div>;
}
